// ABOUTME: Shows GL validity status with an icon and a button to change the price list when status is Error.
// ABOUTME: Used when linking GL nodes to CGT Model to display the GL validity state.

import { Box, Stack, Tooltip } from '@ds/coolshop';
import type { DataTableRow } from '@ds/data-table';
import { ModelGlStatus } from '@src/__generated__/types';
import { ChangeGlPriceListButton } from '@src/modules/hierarchy/ChangeGlPriceListDialog/ChangeGlPriceListButton';
import type { GlStatuses } from '@src/modules/prototype/components/PrototypePanel/hooks/useGlStatuses';
import type { Row } from '@tanstack/react-table';

export function GridCellValidityStatusRenderer({
    modelId,
    row,
    glsStatuses,
}: {
    modelId: string;
    row: Row<DataTableRow>;
    glsStatuses: GlStatuses[];
}) {
    const gl = glsStatuses.find(g => g.glId === row.original.id);
    // statuses[0] is the validity status one
    const glStatus = gl?.statuses[0];

    return (
        <Stack direction="row" alignItems="center" justifyContent="center" gap={1}>
            <Tooltip title={glStatus?.name ?? ''}>{glStatus?.icon ?? <Box />}</Tooltip>
            <ChangeGlPriceListButton
                modelId={modelId}
                glId={row.original.id}
                isError={glStatus?.status === ModelGlStatus.Error}
                hasCompatiblePriceLists={gl?.hasCompatiblePriceLists ?? false}
            />
        </Stack>
    );
}
